import { ErrorResponse } from "../../../utils/types/generals"

export type DeleteDestination = {
    code: string,
    message: string
} & ErrorResponse

export enum CodeDeleteDestination {
    SUCCESS = '00'
}

export enum CodeEditDestination {
    SUCCESS = '01'
}